export const getErrorDescription = (error) => {
    let description;
    if (error instanceof Error) {
        description = error.message;
    }
    else if (error instanceof Response) {
        description = `${error.status} ${error.statusText}`;
    }
    else {
        description = JSON.stringify(error);
    }
    return description;
};
//# sourceMappingURL=getErrorDescription.js.map